import { useState } from 'react';
import { Select } from 'antd';
import { useListBatchesQuery } from '../api/stockApi';
import { formatDate } from '@/shared/lib/date';
import { useBreakpoint } from '@/shared/lib/hooks';
import { PickerSheet } from '@/shared/ui/inputs';

export interface BatchSelectProps {
  categoryId?: string;
  value?: string;
  onChange: (id: string | undefined) => void;
  disabled?: boolean;
}

/** §11.4: выбор партии для списания — только с остатком, иначе LIFO по умолчанию. */
export function BatchSelect({ categoryId, value, onChange, disabled }: BatchSelectProps) {
  const { data = [], isFetching } = useListBatchesQuery(categoryId ?? '', { skip: !categoryId });
  // Телефон: список партий — в нижнем листе (строки с пальцем, первая — «LIFO по умолчанию»).
  const { isMobile } = useBreakpoint();
  const [sheetOpen, setSheetOpen] = useState(false);
  const options = data.map((b) => ({
    value: b.id,
    label: `${formatDate(b.receivedDate)} · ост. ${b.qtyRemaining} · ${b.unitCost}`,
  }));

  if (isMobile) {
    return (
      <>
        <Select<string>
          value={value}
          allowClear
          disabled={disabled || !categoryId}
          loading={isFetching}
          placeholder="LIFO"
          style={{ width: '100%' }}
          onChange={(v) => onChange(v)}
          options={options}
          open={false}
          onOpenChange={(next) => {
            if (next) setSheetOpen(true);
          }}
        />
        <PickerSheet
          open={sheetOpen}
          onClose={() => setSheetOpen(false)}
          title="Партия"
          items={options}
          selected={value ? [value] : []}
          loading={isFetching}
          emptyText="Партий с остатком нет"
          clearLabel="LIFO (по умолчанию)"
          onClear={() => {
            onChange(undefined);
            setSheetOpen(false);
          }}
          onPick={(id) => {
            onChange(id);
            setSheetOpen(false);
          }}
        />
      </>
    );
  }

  return (
    <Select<string>
      value={value}
      allowClear
      disabled={disabled || !categoryId}
      loading={isFetching}
      placeholder="LIFO"
      style={{ width: '100%' }}
      onChange={(v) => onChange(v)}
      options={options}
    />
  );
}
